export const NAME_MIN = 2;
export const NAME_MAX = 50;
export const NAME_REGEX = /^[A-Za-z][A-Za-z\s'-]*[A-Za-z]$/;

export type NameValidationError =
  | "name_required"
  | "name_too_short"
  | "name_too_long"
  | "name_invalid_chars";

export function validateName(
  input: unknown,
): { ok: true; name: string } | { ok: false; error: NameValidationError } {
  if (typeof input !== "string") return { ok: false, error: "name_required" };
  const name = input.trim();
  if (name.length === 0) return { ok: false, error: "name_required" };
  if (name.length < NAME_MIN) return { ok: false, error: "name_too_short" };
  if (name.length > NAME_MAX) return { ok: false, error: "name_too_long" };
  if (!NAME_REGEX.test(name)) return { ok: false, error: "name_invalid_chars" };
  return { ok: true, name };
}
